import { isStringEmptyOrNull } from "../../../../utils/common";
import { MSG_EMPTY_REQUIRED } from "../../../../utils/messages";

export const validateDonationForm = (values) => {
    let errors = {};
    
    if(isStringEmptyOrNull(values.purpose)){
        errors.purpose = MSG_EMPTY_REQUIRED;
    }

    return errors;
    
}